// extracted by mini-css-extract-plugin
export default {"inputMaskStyles":"inputMaskStyles_RWGLq","textalignRight":"textalignRight_f_eu6","textalignLeft":"textalignLeft_hxloC","textalignCenter":"textalignCenter_MYUow"};